/*eslint-disable*/
import React from "react";

// @material-ui/core components
import { Container, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";

import SocialLinks from "components/SocialLinks/SocialLinks.js";

export default function Footer() {
  return <footer className="footer" data-background-color="black" style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#2c2c2c', marginTop: '10px' }}>
    <Container style={{ alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
      <div className="copyright float-left">
        <a href="/page/TerminosCondiciones">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Términos y condiciones</h6>
        </a>
        <a href="/page/PoliticasDatosPersonales">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Política de Tratamiento de Datos Personales</h6>
        </a>
        <a href="/page/PoliticasDerechosAutor">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Politícas de derechos de autor</h6>
        </a>
        <a href="/page/CertificadoAccesibilidad">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Certificado de Accesibilidad</h6>
        </a>
        <a href="/page/PoliticasPrivacidadWeb">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Políticas de Privacidad web</h6>
        </a>
        <a href="/page/MapaSitio">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Mapa del Sitio</h6>
        </a>
        <a href="/page/home#contacts">
          <h6 className="info-title texto" style={{ textAlign: 'left', cursor: "pointer", color: 'white' }}>Canal de Atencion al Publico</h6>
        </a>
        <h6 className="info-title texto" style={{ textAlign: 'left', color: 'white' }}>Dirección: Calle 49B N° 64B-61 Bloque 6 Suramericanas Medellín, Antioquia</h6>
        <h6 className="info-title texto" style={{ textAlign: 'left', color: 'white' }}>Teléfono – Conmutador: +57 (604) 2 603 062</h6>
      </div>
      <div className="copyright" id="copyright" style={{ float: 'right' }} >
        <NavbarBrand to="/" tag={Link} id="navbar-brand">
          <img style={{ backgroundColor: 'white', borderRadius:'15px' }} src={require("assets/img/notaria/logoNavbar.png")} alt="Logo de la notaria 14 Medellin" width="160px"></img>
        </NavbarBrand>
      </div>
    </Container>
    <div className="footer-social" style={{ clear: 'both', display: 'flex', justifyContent: 'center', width: '100%', padding: '8px 15px 4px' }}>
      <SocialLinks />
    </div>
    <div className="div-sinfony" style={{ clear: 'both', backgroundColor: '#474747', width: '100%', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
      © {new Date().getFullYear()}, Designed by{'\u00A0'}
      <a
        href="https://www.sinfony.com.co/sinfony/"
        target="_blank"
        rel="noopener noreferrer"
        style={{color: 'white'}}
      >
        SINFONY Todos los derechos reservados.
      </a>
    </div>
  </footer>
}
